import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CONSTANTS from '../../../util/constant/CONSTANTS';
import { FOND_MODES } from '../../../util/functions';
import CRUDComponent from '../../../component/common/CRUD-Component';
import { Card, Row } from 'antd';
import Heading from '../../../component/common/Heading';
import BackButton from '../../../component/common/Back-Button';

const ModeFeedbackDetails = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    return (
        <div className='my-5'>
            <Card>
                <BackButton onClick={() => navigate(-1)} />
                <Heading>Mode FeedBack Details</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: CONSTANTS.API.Mode_User_Feedback.getAll,
                            extraQuery: {
                                modeFeedbackQuestionId: id
                            },
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `UF${data?.id.toString().padStart(7, "0")}`,
                                        modeD: FOND_MODES[data?.mode] || '-',
                                        user: data?.user?.name || '-',
                                        email: data?.user?.email || '-',
                                        mobile: data?.user?.mobile ? `+${data?.user?.countryCode || ''} ${data?.user?.mobile} ` : '-',

                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.USER_MODE_FEEDBACK,
                        }}
                        FILTERSORTKEY={
                            { "modeD": 'mode' }
                        }
                        isSearch={true}
                    />
                </Row>
            </Card>
        </div>
    )
}

export default ModeFeedbackDetails